import Papa from 'papaparse';

export const SYNONYM_EXPORT_FIELDS = Object.freeze([
  'source',
  'target',
  'direction',
  'status',
]);

export function buildSynonymExportRows(synonyms = []) {
  return synonyms.flatMap((synonym) => {
    const left = (Array.isArray(synonym.left) ? synonym.left : [synonym.left])
      .map(term => String(term == null ? '' : term).trim())
      .filter(Boolean);
    const right = (Array.isArray(synonym.right) ? synonym.right : [synonym.right])
      .map(term => String(term == null ? '' : term).trim())
      .filter(Boolean);

    return left.flatMap(source => right.map(target => ({
      source,
      target,
      direction: synonym.bidirectional ? 'bidirectional' : 'one-way',
      status: synonym.enabled === false ? 'disabled' : 'enabled',
    })));
  });
}

export function buildSynonymsCsv(synonyms = []) {
  return `\uFEFF${Papa.unparse({
    fields: SYNONYM_EXPORT_FIELDS,
    data: buildSynonymExportRows(synonyms),
  }, {
    newline: '\r\n',
  })}`;
}

export function downloadSynonymsCsv(synonyms, date = new Date()) {
  const blob = new Blob([buildSynonymsCsv(synonyms)], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const datePart = date.toISOString().slice(0, 10);

  link.href = url;
  link.download = `kea-synonyms-${datePart}.csv`;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
